import { Col, Row } from "react-bootstrap";
import { Control } from "react-hook-form";

import { ReferentialType } from "../../../_constants/referentialType.ts";
import { DatePickerForm } from "../../../common/components/form/DatePickerForm.tsx";
import Input from "../../../common/components/form/Input.tsx";
import SelectForm from "../../../common/components/form/SelectForm.tsx";
import ToggleButtonForm from "../../../common/components/form/ToggleButtonForm.tsx";
import { ConstructionPeriod } from "../../../common/enums/sharedEnums.ts";
import { IReferentials } from "../../referential/reducers";

export interface DwellingFormFeatureProps {
  control: Control<any>;
  referentials: IReferentials;
}

const BuildingFeatureForm = ({
  referentials,
  control,
}: DwellingFormFeatureProps) => {
  return (
    <>
      <Row>
        <Col md={3}>
          <Input
            label={"Référence interne :"}
            control={control}
            name={"internalReference"}
          />
        </Col>
        <Col md={3}>
          <Input
            label={"Nom du bailleur :"}
            control={control}
            name={"lessorName"}
            rules={{
              required: "Veuillez renseigner le nom du bailleur",
            }}
          />
        </Col>
        <Col md={3}>
          <Input
            label={"N° de copropriété :"}
            control={control}
            name={"condominiumNumber"}
          />
        </Col>
        <Col md={3}>
          <Input
            label={"Références cadastrales :"}
            control={control}
            name={"cadastralReference"}
          />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col md={3}>
          <SelectForm
            label={"Période de construction"}
            defaultValue={referentials[
              ReferentialType.DWELLING_CONSTRUCTION_PERIOD
            ].data.find((item) => item.value === ConstructionPeriod.AFTER_1997)}
            labelInfos={
              <div>
                Vous ne connaissez pas la période de construction ? Consultez
                &nbsp;
                <a
                  href="https://dwell.immo"
                  className="propertyAdressLink link-td"
                >
                  le registre de copropriété
                </a>
              </div>
            }
            rules={{
              required: "Veuillez renseigner la période de construction",
            }}
            name={"constructionPeriod"}
            control={control}
            options={
              referentials[ReferentialType.DWELLING_CONSTRUCTION_PERIOD].data
            }
          />
        </Col>
        <Col md={3}>
          <DatePickerForm
            control={control}
            name="constructionDate"
            label="Date exacte"
          />
        </Col>
        <Col md={3}>
          <ToggleButtonForm
            control={control}
            defaultValue={false}
            label={"Système de chauffage :"}
            name={"isCollective"}
            leftToggle={"Collectif"}
            rightToggle={"Individuel"}
          />
        </Col>
        <Col md={3}>
          <ToggleButtonForm
            control={control}
            defaultValue={false}
            label={"Zone termites ?"}
            labelInfos={
              <div>
                <p>
                  Vous ne savez pas s’il s’agit d’une zone termites ? Consultez
                  &nbsp;
                  <a
                    href="https://dwell.immo"
                    className="propertyAdressLink link-td"
                  >
                    l’observatoire National Termites
                  </a>
                </p>
              </div>
            }
            name={"isTermiteZone"}
            leftToggle={"Oui"}
            rightToggle={"Non"}
          />
        </Col>
      </Row>
    </>
  );
};
export default BuildingFeatureForm;
